import { createSelector } from 'reselect'

const getLibraries = state => state.libraries

const getLessons = createSelector(
	[
		getLibraries,
	],
	libraries => ({
		more: libraries.current.search.more,
		libraryUID: libraries.current.libraryUID,
		folderUID: libraries.current.folderUID,
		search: libraries.current.search,
	})
)

export default getLessons
